import { Extensions, mergeAttributes } from "@tiptap/react"
import { BulletList } from "@tiptap/extension-bullet-list"
import { Document } from "@tiptap/extension-document"
import { Heading } from "@tiptap/extension-heading"
import { History } from "@tiptap/extension-history"
import { Italic } from "@tiptap/extension-italic"
import { Bold } from "@tiptap/extension-bold"
import { ListItem } from "@tiptap/extension-list-item"
import { OrderedList } from "@tiptap/extension-ordered-list"
import { Paragraph } from "@tiptap/extension-paragraph"
import { Text } from "@tiptap/extension-text"
import { Underline } from "@tiptap/extension-underline"
import { Placeholder } from "@tiptap/extension-placeholder"

import { Headings, mapTagsToStyles } from "../Heading"

export const getExtensions = (placeholder?: string): Extensions => {
  const extensions: Extensions = [
    Underline.configure({
      HTMLAttributes: { class: "underline" },
    }),
    Bold,
    BulletList.configure({ HTMLAttributes: { class: "list-disc pl-4" } }),
    Document,
    Heading.configure({ levels: [1, 2, 3] }).extend({
      // From https://github.com/ueberdosis/tiptap/issues/1514#issuecomment-886752162
      // Ensures that H tags have same styles as <Heading/> components
      renderHTML({ node, HTMLAttributes }) {
        const hasLevel = this.options.levels.includes(node.attrs.level)
        const level: number = hasLevel ? node.attrs.level : this.options.levels[0]
        const tag = `h${level}`

        return [
          tag,
          mergeAttributes(this.options.HTMLAttributes, HTMLAttributes, {
            class: `${mapTagsToStyles[tag as Headings]}`,
          }),
          0,
        ]
      },
    }),
    History,
    Italic,
    ListItem,
    OrderedList.configure({ HTMLAttributes: { class: "list-decimal pl-4" } }),
    Paragraph,
    Text,
  ]

  if (placeholder && placeholder.length > 0) {
    extensions.push(
      Placeholder.configure({
        placeholder,
        emptyNodeClass:
          // Add styling so that it looks like a placeholder
          // `first:` ensures that the placeholder only appears in the first node of the editor
          // `float-left` ensures that the cursor flashes on the left when the editor is active
          "text-gray-300 first:before:pointer-events-none first:before:float-left first:before:h-0 first:before:content-[attr(data-placeholder)]",
      }),
    )
  }

  return extensions
}
